/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { Controller } from 'react-hook-form';
// material-ui components
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
// custom components
import NumberedHeading from "../../../../../shared-components/forms/NumberedHeading";
import ObjectivesArray from './components/ObjectivesArray';
import EmentorArray from '../shared/EmentorArray';

const Objectives = (props) => {

  const { control, formState } = props.methods;
  const { errors } = formState;

  const { inputDir } = props;

  return (
    <div>
      <NumberedHeading number="1" title="Objectives" instructions='Use the "Add Objective" button below to add an instance of an objective.' required />
      <Controller
        control={control}
        name="content.core"
        render={({ field }) => <ObjectivesArray inputDir={inputDir} {...{ control, errors }} />}
      />

      <Divider className="my-16" />

      <NumberedHeading number="2" title="eMentor Notes" instructions="Using the controls below, add any supplemental content to this page" />

      <Controller
        control={control}
        name="content.eMentor"
        render={({ field }) => <EmentorArray {...{ control, errors }} />}
      />
    </div>
  );
};

export default Objectives;